export default function getProperty (object, key){
    let keys = key.split('.');
    let value = object[keys.shift()];
  
    while (keys.length > 0) {
      value = value[keys.shift()];
    }
  
    return value;
  }